<form name="form" class="form">
  @if(AgencyStyleSheet())
  {
  <link rel="stylesheet"
        type="text/css"
        [href]="AgencyStyleSheet()" media="screen" />
  }
  <div id="ePayPage">
    <div id="ePayHeader">
      <div id="ePayHeaderContent">
        <div id="Header1" class="header1"></div>
        <div id="Header2" class="header2"></div>
        <div id="Header3" class="header3"></div>
      </div>
    </div>
    <div id="ePayContent">
      <div id="LeftPane"></div>
      <div id="CenterPane">
        <h5></h5>
        <h6 class="AgencyName">
          @if(!isLoading)
          {
          <dynamic-directive [body]="AgencyName()"></dynamic-directive>
          }
        </h6>
        @if(CurrentPage()==='unavailable')
        {
        <span id="unavailable" class="unavailable">
          The system is currently undergoing maintenance. Please try again later.
        </span>
        }
        @if(CurrentPage()==='questionnaire')
        {
        <div id="TableCustomPage">
          <div id="MultiPage1" class="questionaire">
            <div class="questionaire-items" id="Table0">
              <prequestionaire [preQuestionItems]="preQuestionItems()">
              </prequestionaire>
            </div>
            <div>
              <span id="RequiredAnswerMessage" class="RequiredAnswerMessage"
                    role="alert" aria-live="assertive"
                    [innerHTML]="RequiredAnswerMessage">
              </span>
            </div>
          </div>
          <div class="questionnaire-errors" role="alert" aria-live="assertive">
            @for (item of errorMessages(); track item) {
            <div>{{item}}</div>
            }
          </div>
          <div class="questionaire-buttons">
            @if(!IsFirstPage())
            {
            <button class="btn btn-primary" (click)="PreviousPage()" type="button">
              <div class="PreviousPage">
                <div class="PreviousPageText">
                  Previous
                </div>
              </div>
            </button>
            }
            @if(!IsLastPage())
            {
            <button class="btn btn-primary btn-success" (click)="NextPage()" [disabled]="!IsPageValid()" type="button">
              <div class="NextPage">
                <div class="NextPageText">
                  Next
                </div>
              </div>
            </button>
            }
            @if(IsLastPage())
            {
            <button class="btn btn-primary btn-success" (click)="NextPage()" [disabled]="!IsFormValid()" type="button">
              <div class="FinishPage">
                <div class="FinishPageText">
                  Pay
                </div>
              </div>
            </button>
            }
          </div>
        </div>
        }
        @if(CurrentPage()==='payment')
        {
        <div>
          <div id="Table1">
            <div class="Instructions-Top">
              <div class="Instructions-TopText">
                Enter the required fields below then select the checkbox regarding the billing statement to continue to the payment information.
              </div>
            </div>
            <div class="paymentOptions-block">
              <div class="">
                @if(PaymentOptions().length > 1)
                {

                <fieldset class="paymentOptions">
                  <legend>Select a payment method</legend>
                  <div class="paymentOptions">
                    @for (paymentOption of PaymentOptions(); track trackByPayment($index, paymentOption))
                    {
                    <span class="paymentOptionsButton">
                      <input type="radio" id="radio{{paymentOption.option}}"
                             name="paymentMethod"
                             [required]="true"
                             [checked]="selectedPaymentOption === ParseInt(paymentOption.option)"
                             (click)="onPaymentOptionClick(paymentOption)">
                      <label for="radio{{paymentOption.option}}">
                        <span class="paymentOptionsText" [innerHTML]="paymentOption.type"></span>
                      </label>

                    </span>
                    }
                  </div>
                </fieldset>
                }
              </div>
            </div>
            <div class="paymentpage-block">
              @if(TotalAmount() > 0)
              {
              <div class="paymentAmount paypageItem">
                <div class="table-cell1">
                  <span class="paymentAmountText">Payment Amount:</span>
                </div>
                <span class="paymentpagePaymentAmount table-cell2">{{amount | currency}}</span>
              </div>
              }
              @if(serviceAmount > 0)
              {
              <div class="paymentpage-servicefee paypageItem">
                <div class="table-cell1">
                  <span class="ServiceFeeText">A service fee of </span>
                </div>
                <span class="ServiceFeeAmount table-cell2">{{serviceAmount | currency}}<span class="ServiceFeeText"> has been added</span></span>
              </div>
              }
              @if(serviceAmount > 0)
              {
              <div class="paymentpage-totalamount paypageItem">
                <div class="table-cell1">
                  <span class="TotalPaymentAmountText">Total Payment Amount:</span>
                </div>
                <span class="table-cell2">{{TotalAmount() | currency}}</span>
              </div>
              }
            </div>
            @if(ShowBilling())
            {
            <div class="paymentPageCustomerInfo">
              @if(selectedPaymentOption===1 ||
              selectedPaymentOption===4 ||
              !selectedPaymentOption)
              {
              <div>
                <div class="paymentpage-company paypageItem">
                  <label class="epaylabel" for="company">Company:</label>
                  <span class="table-cell2 epaycontrol">
                    <input type="text" name="company"
                           id="company" autocomplete="on"
                           class="form-control mb15 input-textbox"
                           [(ngModel)]="company" />
                  </span>
                </div>
                <div class="paymentpage-firstname paypageItem">
                  <label class="epaylabel required-symbol" for="firstname">First Name:</label>
                  <span class="table-cell2 epaycontrol required">
                    <input id="firstname" type="text" [required]="true" name="firstname"
                           class="form-control mb15 input-textbox"
                           #billing_firstname="ngModel" autocomplete="on"
                           [(ngModel)]="firstName" />
                  </span>
                </div>
                <div class="paymentpage-lastname paypageItem">
                  <label class="epaylabel required-symbol" for="lastname">Last Name:</label>
                  <span class="table-cell2 epaycontrol required">
                    <input type="text" [required]="true" id="lastname"
                           class="form-control mb15 input-textbox"
                           #billing_lastname="ngModel" autocomplete="on"
                           name="lastname" [(ngModel)]="lastName" />
                  </span>
                </div>
                <div class="paymentpage-address paypageItem">
                  <span class="outsideUS">
                    <input type="checkbox" name="outsideusname" id="OutsideUS" [(ngModel)]="outsideUS" />
                    <label for="OutsideUS">Outside of US</label><br />
                  </span>
                  <div class="paymentpage-address1 paypageItem">
                    <label class="epaylabel required-symbol" for="address1">Address line 1:</label>
                    <span class="table-cell2 epaycontrol required">
                      <input id="address1" type="text" name="address_1"
                             class="form-control mb15 address1 input-textbox"
                             #billing_address1="ngModel" autocomplete="on"
                             [(ngModel)]="address_1" required />
                    </span>
                  </div>
                  <div class="paymentpage-address2 paypageItem">
                    <label class="epaylabel" for="address2">Address line 2:</label>
                    <span class="table-cell2 epaycontrol">
                      <input id="address2" type="text" name="address_2"
                             class="form-control mb15 address2 input-textbox"
                             #billing_address2="ngModel"
                             [(ngModel)]="address_2" />
                    </span>
                  </div>
                </div>
                <div class="paymentpage-city paypageItem">
                  <label class="epaylabel required-symbol" for="city">City:</label>
                  <span class="table-cell2 epaycontrol required">
                    <input type="text" [required]="true" name="city"
                           #billing_city="ngModel" id="city" autocomplete="on"
                           class="form-control mb15 input-textbox" [(ngModel)]="city" />
                  </span>
                </div>
                @if(!outsideUS)
                {
                <div class="paymentpage-state paypageItem">
                  <label class="epaylabel required-symbol" for="state">State:</label>
                  <span class="table-cell2 epaycontrol required">
                    <states [required]="true"
                            [(state)]="state"></states>
                  </span>
                </div>
                }
                <div class="paymentpage-zipcode paypageItem">
                  <label class="epaylabel required-symbol" for="zipCode">Zip Code:</label>
                  <span class="table-cell2 epaycontrol required">
                    <input type="text" class="form-control mb15 input-textbox"
                           #billing_zipcode="ngModel"
                           [required]="true"
                           name="zipcode"
                           id="zipCode" autocomplete="on"
                           [(ngModel)]="zipCode" />
                  </span>
                </div>
                <div class="paymentpage-phone paypageItem">
                  <label class="epaylabel required-symbol" for="phone">Phone:</label>
                  <span class="table-cell2 epaycontrol required">
                    <input type="text" class="form-control mb15 input-textbox"
                           [required]="true" name="phone"
                           #billing_phone="ngModel"
                           id="phone" autocomplete="on"
                           [(ngModel)]="phone" />
                  </span>
                </div>
                <div class="paymentpage-email paypageItem">
                  <label class="epaylabel" for="email">Email:</label>
                  <span class="table-cell2 epaycontrol">
                    <input type="email"
                           class="form-control mb15 input-textbox"
                           name="emailid"
                           id="email" autocomplete="on"
                           [(ngModel)]="email" />
                  </span>
                </div>
              </div>
              }
              @if(ParseInt(selectedPaymentOption)===6)
              {
              <div>
                <div class="paymentpage-email paypageItem">
                  <label class="epaylabel" for="emailid">Email:</label>
                  <span class="table-cell2 epaycontrol">
                    <input type="email"
                           class="form-control mb15 input-textbox"
                           name="emailName"
                           id="emailid"
                           required
                           [(ngModel)]="email" />
                  </span>
                </div>
                <div class="paymentpage-cardholder paypageItem">
                  <label class="epaylabel" for="cardholdername">Card Holder Name:</label>
                  <span class="epaycontrol cardHolderName">
                    <input type="text" name="cardholdername" id="cardholdername"
                           class="form-control mb15 input-textbox" required
                           [(ngModel)]="cardHolderName" />
                  </span>
                </div>
              </div>
              }
            </div>
            }
            @if(AllowRecurring() && selectedPaymentOption===1)
            {
            <div id="Recurring">
              <input type="checkbox" name="agreeRecurring" id="agreeRecurring" [(ngModel)]="allowRecurring" />
              <span class="RecurringStatement">
                <span class="RecurringStatementText">
                  <label class="RecurringStatement" for="agreeRecurring">Allow recurring payments</label>
                </span>
              </span>
            </div>
            }
            @if(selectedPaymentOption === 6)
            {
            <div class="paymentpage-terminals-device">
              @if(hasMultipleDevices())
              {
              <div>
                <label for="selectedDevice">Select Device</label>
                <select [(ngModel)]="selectedDevice" name="selectedDevice" required
                        class="selectedDevice styled-dropdown" id="selectedDevice">
                  @for(device of devices; track device.hsn)
                  {
                  <option [ngValue]="device" class="input-dropdown-screenvalue">{{ device.description }}</option>
                  }
                </select>
              </div>
              }
              @if(!hasMultipleDevices())
              {
              <div>
                @if(device)
                {
                <label>{{ device.description }}</label>
                }
              </div>
              }
            </div>
            }
            @if(selectedPaymentOption)
            {
            <div id="Billing">
              <input type="checkbox" name="agree" id="agree" [(ngModel)]="agree" [disabled]="!allowAgree" />
              @if(selectedPaymentOption===1 || selectedPaymentOption===6)
              {
              <span class="BillingStatement">
                @if(!IsSnapPay())
                {
                <span class="BillingStatementText">
                  @if(bankStatement)
                  {
                  <label for="agree">I understand that my billing statement will say {{bankStatement}}.</label>
                  }
                </span>
                @if(serviceAmount > 0 && IsSnapPay())
                {
                <span class="BillingStatementSplit">
                  <label for="agree">I understand for credit card payment that the service fee will be a separate charge on my credit card statement</label>
                </span>
                }
                }
              </span>
              }
              @if(selectedPaymentOption===4)
              {
              <span class="BillingStatement">
                <span class="BillingStatementText">
                  <label for="agree">I understand that my billing statement will say West Virginia State Treasurer.</label>
                </span>
              </span>
              }
            </div>
            }
            @if(PreQuestionare())
            {
            <button class="btn btn-primary" (click)="PreviousPage()" type="button" [disabled]="isSubmitting">
              <div class="PreviousPage">
                <div class="PreviousPageText">
                  Previous
                </div>
              </div>
            </button>
            }
            @if(!agree)
            {
            <button class="btn btn-warning ccBtnCancel" (click)="cancel()" type="button">
              <div class="CancelPayment">
                <div class="CancelPaymentText">
                  Cancel
                </div>
              </div>
            </button>
            }
            @if(agree)
            {
            <div class="d-block">
              @if(isSubmitting)
              {
              <div class="submitting" role="status" aria-live="polite" aria-atomic="true">
                <!-- Processing Graphic -->
                <div class="lds-css ng-scope">
                  <div class="lds-spin">
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <span class="sr-only">Processing your payment</span>
                <!-- End Processing Graphic -->
              </div>
              }
              <div>
                @if(selectedPaymentOption)
                {
                <div class="iframeTop d-block" [attr.aria-busy]="isSubmitting ? 'true' : null">
                  @if(selectedPaymentOption === 1)
                  {
                  <div class="paymentpage-creditcard paypageItem">
                    @if(!isSubmitting)
                    {
                    <div class="iframe">
                      @if(TotalAmount() > 0)
                      {
                        <apple-pay (makePayment)="sendWalletPayment('APLE', $event)"></apple-pay>
                        <google-pay (makePayment)="sendWalletPayment('GOGLE',null)"></google-pay>
                      }
                      @if(ShowBilling())
                      {
                      <div class="paymentpage-cardholder paypageItem">
                        <label class="epaylabel" for="cardHolderName">Card Holder Name:</label>
                        <span class="epaycontrol cardHolderName">
                          <input type="text" name="cardholdername" id="cardHolderName"
                                 class="form-control mb15 input-textbox"
                                 [(ngModel)]="cardHolderName" />
                        </span>
                        <label class="diffName" for="cardHolderName">If different than above</label>
                      </div>
                      }
                      @if(credit_card)
                      {
                      <div class="d-inline-block creditCardInfo">
                        <credit-card [(carddata)]="carddata" name="card">
                        </credit-card>
                      </div>
                      }
                      <div class="errormessages" role="alert" aria-live="assertive">
                        @for(msg of invalidmessages; track msg)
                        {
                        <div>
                          {{msg}}
                        </div>
                        }
                      </div>
                      @if(!IsAuthorizeOnly())
                      {
                      <div class="ccPayButtons">
                        <span class="ccPay">
                          <button class="btn btn-primary" (click)="sendCardPayment(true)"
                                  [disabled]="!isCardDataValid || !allowAgree"
                                  type="button">
                            @if(TotalAmount() > 0)
                            {
                            <span class="PaymentPagePay">
                              <span class="PaymentPageText">
                                Pay
                              </span>
                            </span>
                            }
                            @if(TotalAmount() == 0)
                            {
                            <span class="PaymentPagePay PaymentPageRecurring">
                              <span class="PaymentPageText PaymentPageRecurring">
                                Save
                              </span>
                            </span>
                            }
                          </button>
                          <button class="btn btn-warning ccBtnCancel" (click)="cancel()" type="button">
                            <span class="CancelPayment">
                              <span class="CancelPaymentText">
                                Cancel
                              </span>
                            </span>
                          </button>
                        </span>
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                  @if(selectedPaymentOption === 4)
                  {
                  <div class="paymentpage-ach paypageItem">
                    @if(!isSubmitting)
                    {
                    <div>
                      <div class="achAccountName">
                        <label for="achAccountName">Account Holder Name</label>
                        <input id="achAccountName" type="text" name="accountname" placeholder="Account Holder Name"
                               [(ngModel)]="account_Name"
                               #accountName="ngModel" minlength="4"
                               class="form-control mb15 input-textbox" [required]="true"
                               [attr.aria-invalid]="accountName.invalid && accountName.touched ? 'true' : null"
                               aria-describedby="achAccountNameError" />
                        @if(accountName.invalid && accountName.touched)
                        {
                        <div id="achAccountNameError" class="field-error" role="alert" aria-live="assertive">
                          <span>Please enter an account name.</span>
                        </div>
                        }
                      </div>
                      <div class="achRouting paypageItem">
                        <label for="routingNumber">Routing Number</label>
                        <input id="routingNumber" type="text" name="routingnumber" placeholder="Routing Number"
                               #routingNumber="ngModel"
                               [(ngModel)]="routing_Number"
                               aba-validator
                               class="form-control mb15 input-textbox" [required]="true"
                               [attr.aria-invalid]="routingNumber.invalid && routingNumber.touched ? 'true' : null"
                               aria-describedby="routingNumberError" />
                        @if(!routingnumbervalid && routingNumber.touched)
                        {
                        <div id="routingNumberError" class="field-error" role="alert" aria-live="assertive">
                          <span>Enter a valid routing number.</span>
                        </div>
                        }
                      </div>
                      <div class="achAccountNumber1 paypageItem">
                        <label for="accountNumber">Account Number</label>
                        <input id="accountNumber" type="text" #accountNumber="ngModel" name="accountnumber"
                               placeholder="Account Number" minlength="5"
                               [(ngModel)]="account_Number"
                               validateEqual="accountNumberDup"
                               class="form-control mb15 input-textbox" [required]="true"
                               [attr.aria-invalid]="accountNumber.invalid && accountNumber.touched ? 'true' : null"
                               aria-describedby="accountNumberError" />
                        @if(accountNumber.invalid && accountNumber.touched)
                        {
                        <div id="accountNumberError" class="field-error" role="alert" aria-live="assertive">
                          <span>Enter your account number.</span>
                        </div>
                        }
                      </div>
                      <div class="achAccountNumber2 paypageItem">
                        <label for="accountNumberDup">Re-enter Account Number</label>
                        <input id="accountNumberDup" type="text" name="accountnumberDup" placeholder="Re Enter Account Number"
                               [(ngModel)]="account_Numberdup" minlength="5"
                               #accountNumberDup="ngModel"
                               validateEqual="accountNumber"
                               class="form-control mb15 input-textbox" [required]="true"
                               [attr.aria-invalid]="accountNumberDup.invalid && accountNumberDup.touched ? 'true' : null"
                               aria-describedby="accountNumberDupError" />
                        @if(accountNumberDup.invalid && accountNumberDup.touched)
                        {
                        <div id="accountNumberDupError" class="field-error" role="alert" aria-live="assertive">
                          <span>Please re-enter the same account number.</span>
                        </div>
                        }
                      </div>
                      <div>
                        <span class="achPay paypageItem">
                          <button class="btn btn-primary btn-success" (click)="AchPaymentResults()"
                                  [disabled]="!accountNumberDup.valid ||
                                       !accountNumber.valid ||
                                       !routingNumber.valid ||
                                       !accountName.valid ||
                                       !allowAgree" type="button"
                                  value="Pay" name="Pay">
                            <span class="PaymentPagePay">
                              <span class="PaymentPageText">
                                Pay
                              </span>
                            </span>
                          </button>
                          <button class="btn btn-warning achBtnCancel" (click)="cancel()" type="button">
                            <span class="CancelPayment">
                              <span class="CancelPaymentText">
                                Cancel
                              </span>
                            </span>
                          </button>
                        </span>
                      </div>
                    </div>
                    }
                  </div>
                  }
                  @if(selectedPaymentOption === 6)
                  {
                  <div class="paymentpage-terminals paypageItem">
                    <div class="paymentPageCustomerInfo">
                      <div class="paymentpage paypageItem">
                        <div class="devicePaymentButton paypageItem">
                          <div>
                            <button class="btn btn-primary btn-swipe" type="button" (click)="useDevice()"
                                    [disabled]="!hsn
                                    || !cardHolderName
                                    || !email
                                    || isTerminalSubmitting">
                              <span class="use-device">
                                <span class="use-devicetext">Swipe Card</span>
                              </span>
                            </button>
                            @if(isTerminalSubmitting)
                            {
                            <button class="btn btn-primary btn-swipe ccBtnCancel" type="button" (click)="cancelTerminal()">
                              <span class="use-device-cancel">
                                <span class="use-devicetext-cancel">Cancel</span>
                              </span>
                            </button>
                            }
                            @if(!isTerminalSubmitting)
                            {
                            <button class="btn btn-warning ccBtnCancel swipeBtnCancel" (click)="cancel()" type="button">
                              <span class="CancelPayment">
                                <span class="CancelPaymentText">Cancel</span>
                              </span>
                            </button>
                            }
                          </div>
                          <div>
                            @if(!isTerminalSubmitting)
                            {
                            <button class="btn btn-primary btn-swipe" type="button" (click)="useDeviceEnter()"
                                    [disabled]="!hsn
                                    || !cardHolderName 
                                    || !email">
                              <span class="use-device">
                                <span class="use-devicetext">Enter Card</span>
                              </span>
                            </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        }
        @if(CurrentPage()==='confirmation')
        {
        <div id="Confirmation">
          @if(processState === 'CompletedOk')
          {
          <div class="paymentSuccess">
            <div class="confirmation-buttons-top">
              <button class="btn btn-primary btn-printpage" type="button" onclick="window.print()">
                <div class="PrintPage">
                  <div class="PrintPageText">
                    Print
                  </div>
                </div>
              </button>
              <button class="btn btn-primary btn-continue" (click)="NextPage()" type="button">
                <div class="NextPage">
                  <div class="NextPageText">
                    Continue
                  </div>
                </div>
              </button>
            </div>
            <div class="">
              <div class="cardPayment">
                @if(TotalAmount() > 0)
                {
                <div class="cardPaymentSuccess">Payment Successful</div>
                }
                @if(TotalAmount() == 0)
                {
                <div class="cardPaymentSuccess cardNoPaymentSuccess">Captured Successful</div>
                }
              </div>
            </div>
            <div class="confirmationNumber confirmationPgInfo">
              <div class="table-cell1">
                <div class="paymentSuccessConf">Confirmation Number:</div>
              </div>
              <div class="table-cell2">
                <div class="successConf">{{IotpTransId()}}</div>
              </div>
            </div>
            <div class="paymentDate confirmationPgInfo">
              <div class="table-cell1">
                <div class="successpaymentDateLabel">Payment Date:</div>
              </div>
              <div class="table-cell2">
                <div class="successpaymentDate">{{PaymentDate()}}</div>
              </div>
            </div>
            @if(TotalAmount() > 0)
            {
            <div class="amountCharged confirmationPgInfo">
              <div class="table-cell1">
                <div class="paymentSuccessAmount">Amount Charged:</div>
              </div>
              <div class="table-cell2">
                <div class="successAmount">{{TotalAmount()  | currency}}</div>
              </div>
            </div>
            }
            @if(TotalAmount() > 0)
            {
            <div class="customerName confirmationPgInfo">
              @if(selectedPaymentOption !== 6)
              {
              <div class="">
                <div class="table-cell1">
                  <div class="paymentSuccessName">Name:</div>
                </div>
                <div class="table-cell2">
                  <div class="successName">{{firstName}}&nbsp;{{lastName}}</div>
                </div>
              </div>
              }
              @if(selectedPaymentOption !== 6)
              {
              <div class="customerAddress confirmationPgInfo">
                <div class="table-cell1">
                  <div class="paymentSuccessAddress">Address:</div>
                </div>
                <div class="table-cell2">
                  <div class="successAddress">
                    <div class="addr1">{{address_1}}</div>
                    <div class="addr2">
                      @if(address_2)
                      {
                      <span>{{address_2}}</span>
                      }
                    </div>
                    <div class="addr3">{{city}}&nbsp;{{state}}&nbsp;{{zipCode}}</div>
                  </div>
                </div>
              </div>
              }
              @if(selectedPaymentOption !== 6)
              {
              <div class="customerEmail confirmationPgInfo">
                <div class="table-cell1">
                  <div class="paymentSuccessEmail">Email:</div>
                </div>
                <div class="table-cell2">
                  <div class="successEmail">{{email}}</div>
                </div>
              </div>
              }
              @if(selectedPaymentOption !== 6)
              {
              <div class="customerPhone confirmationPgInfo">
                <div class="table-cell1">
                  <div class="paymentSuccessPhone">Phone:</div>
                </div>
                <div class="table-cell2">
                  <div class="successPhone">{{phone}}</div>
                </div>
              </div>
              }
              @if((selectedPaymentOption === 1 || selectedPaymentOption === 6) && fullName)
              {
              <div class="cardHolderNameSuccess confirmationPgInfo">
                <div class="">
                  <div class="table-cell1">
                    <div class="paymentSuccessCard">Card Holder Name:</div>
                  </div>
                  <div class="table-cell2">
                    <div class="successCard">{{fullName}}</div>
                  </div>
                </div>
              </div>
              }
            </div>
            }
            <div class="ConfirmationBillingStatement">
              <div class="ConfirmationBillingStatementText">
                @if(bankStatement)
                {
                Your billing statement will say {{bankStatement}}
                }
              </div>
              <div class="successPrint">
                Please Print this page for your records
              </div>
            </div>
            <div class="confirmation-buttons-top">
              <button class="btn btn-primary btn-printpage" type="button" onclick="window.print()">
                <div class="PrintPage">
                  <div class="PrintPageText">
                    Print
                  </div>
                </div>
              </button>
              <button class="btn btn-primary btn-continue" (click)="NextPage()" type="button">
                <div class="NextPage">
                  <div class="NextPageText">
                    Continue
                  </div>
                </div>
              </button>
            </div>
          </div>
          }
          @if(processState === 'Failed')
          {
          <div class="paymentFailed">
            <div class="">
              @if(TotalAmount() > 0)
              {
              <div class="paymentFailed">
                @if(selectedPaymentOption === 4)
                {
                <div class="achFailed">
                  Invalid banking information entered payment not processed.  Please contact your bank to verify banking information for eChecks Payments.
                </div>
                }
                @if(selectedPaymentOption === 1)
                {
                <div class="creditCardFailed">
                  <div class="paymentFailedText">Payment Failed</div>
                </div>
                }
              </div>
              }
              @if(TotalAmount() == 0)
              {
              <div class="paymentFailed">
                <div class="paymentFailedText">Capture Failed</div>
              </div>
              }
            </div>
            <div class="">
              <div class="table-cell1">
                <div class="paymentFailedTransaction">Transaction Number:</div>
              </div>
              <div class="table-cell2">
                <div class="failedTranscationID">{{IotpTransId()}}</div>
              </div>
            </div>
            <div class="paymentDate confirmationPgInfo">
              <div class="table-cell1">
                <div class="successpaymentDateLabel">Payment Failed Date:</div>
              </div>
              <div class="table-cell2">
                <div class="successpaymentDate">{{PaymentDate()}}</div>
              </div>
            </div>
            <div class="">
              <div class="table-cell1">
                <div class="paymentFailedAmount">Amount:</div>
              </div>
              <div class="table-cell2">
                <div class="failedAmount">{{TotalAmount()  | currency}}</div>
              </div>
            </div>
            @if(selectedPaymentOption === 1)
            {
            <div class="paymentFailedDescription">
              The payment failed please verify the card number and expiration date and retry the payment.
            </div>
            }
            <div class="confirmation-buttons-top">
              <button class="btn btn-primary btn-printpage" type="button" onclick="window.print()">
                <div class="PrintPage">
                  <div class="PrintPageText">
                    Print
                  </div>
                </div>
              </button>
              <button class="btn btn-primary btn-retry" (click)="PreviousPage()" type="button">
                <div class="NextPage">
                  <div class="NextPageText">
                    Retry
                  </div>
                </div>
              </button>
            </div>
          </div>
          }
        </div>
        }
        @if(CurrentPage() === 'redirecting')
        {
        <div id="Confirmation">
          <div class="redirecting" role="status" aria-live="polite" aria-atomic="true">
            <!-- Processing Graphic -->
            <div class="lds-css ng-scope">
              <div class="lds-spin">
                <div>
                  <div>
                  </div>
                </div>
                <div>
                  <div>
                  </div>
                </div>
                <div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                </div>
              </div>
            </div>
            <div class="text-align-center">Processing</div>
            <span class="sr-only">Redirecting, please wait</span>
            <!-- End Processing Graphic -->
          </div>
        </div>
        }
      </div>
      <!--CenterPane-->
      <div id="RightPane"></div>
    </div><!--ePayContent-->
    <div id="ePayFooter">
      <div id="Footer1"></div>
      <div id="Footer2"></div>
      <div id="Footer3"></div>
    </div><!--ePayFooter-->
  </div><!--ePayPage-->
  @if(IsInTestingMode())
  {
  <div class="alert-danger alert">
    System is currently in testing mode
  </div>
  }
</form>
